import ZoneItem from 'pages/Map/components/ZoneItem';
import ZoneTileHeader from 'pages/Map/components/ZoneTileHeader';
import useRegion from 'hooks/user/useRegion';
import { CenterAlignedLoader } from '@medly-components/core';
import { MapContainer, MapsSubHeader, MapZones } from './MapDetails.styled';
import { type AssignedMaps } from '../AssignedMaps';

type MapDetails = {
    userId: string;
    regionId: string;
    onZoneClick: AssignedMaps['onZoneClick'];
};
export const MapDetails = ({ userId, regionId, onZoneClick }: MapDetails) => {
    const { region, isLoading } = useRegion(userId, regionId);

    if (isLoading || !region) {
        return (
            <div style={{ minHeight: '10rem' }}>
                <CenterAlignedLoader />
            </div>
        );
    }

    return (
        <MapContainer>
            <MapsSubHeader>
                <ZoneTileHeader region={region} />
            </MapsSubHeader>
            <MapZones>
                {region.zones.map((zone, index) => (
                    <ZoneItem
                        key={zone.name}
                        onClick={() => onZoneClick(region.name, zone.name)}
                        zone={zone}
                        number={index + 1}
                        isActive={region.position?.zone === zone.name}
                    />
                ))}
            </MapZones>
        </MapContainer>
    );
};
